var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-users"},[(_vm.projectUsers.length)?_c('Table',{attrs:{"title":"Users with access","rows":_vm.projectUsers,"fields":_vm.fields},on:{"rowClick":_vm.onUserRowClick}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }